<template>
  <!-- <pre v-if="responseData"> testData={{ responseData }}</pre> -->
  <AdminBackground v-if="responseData">
    <div class="image-wrapper">
      <img
        src="@/assets/header/PREMIS MAKANAN.png"
        alt="PREMIS MAKANAN"
        class="pbt-image"
      >
      <div class="line-under-image" />
    </div>
    <div class="content-wrapper">
      <h2>PROGRAM KESELAMATAN DAN KUALITI MAKANAN</h2>
      <div class="input-row">
        <div class="input-item">
          <AppAutocomplete
            v-model="selectedYear"
            label="Tahun"
            :items="years"
            placeholder="Pilih Tahun"
            chips
            class="app-date-picker"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedsState"
            label="Negeri"
            :items="states"
            placeholder="Pilih Negeri"
            chips
            multiple
            closable-chips
            class="app-date-picker"
            @update:model-value="handleStateChange"
          />
        </div>

        <div class="input-item">
          <AppAutocomplete
            v-model="selectedPbt"
            label="Pihak Berkuasa Tempatan"
            :items="pbt"
            placeholder="Pilih PBT"
            class="app-date-picker"
            chips
            multiple
            closable-chips
            @update:model-value="handleStateChange"
          />
        </div>
      </div>

      <h2>PEMERIKSAAN DAN PENGGREDAN PREMIS MAKANAN</h2>
      <div class="first-row">
        <div
          v-for="(item, index) in premis.slice(0, 2)"
          :key="index"
          :style="{ background: item.color }"
          class="box"
        >
          <p>{{ item.title }}</p>
          <span class="count">{{ item.location }}</span>
        </div>
      </div>

      <div class="second-row">
        <div
          v-for="(item, index) in premis.slice(2)"
          :key="index"
          class="box small"
          :style="{ background: item.color }"
        >
          <p>{{ item.title }}</p>
          <span class="count">{{ item.location }}</span>
        </div>
      </div>

      <Update />
    </div>

    <div class="content-wrapper">   
      <h2>GRED PREMIS</h2>
      <div class="chart-wrapper">
        <DoubleBar 
          :chart-data="GredPermisData"
          :chart-categories="GredPermisNames"
          :legend-labels="['Gred A', 'Gred B', 'Gred C']"
          :series-colors="['#029708', '#FFD700', '#FF0000']"
        />
      </div>
      <!--
        <div class="chart-note">
        Arahkan kursor pada graf untuk melihat maklumat terperinci
        </div> 
      -->
    </div>

    <div class="content-wrapper">
      <h2>TINDAKAN PENGUATKUASAAN</h2>
      <div class="premis">
        <div
          v-for="(tindakan, index) in tindakanData"
          :key="index"
          class="premis-container"
        >
          <img
            src="@/assets/spah/box.png"
            :alt="tindakan.altText"
            class="responsive-image"
          >
          <div class="text-overlay">
            <div class="values-layered">
              <h3>{{ tindakan.title }}</h3>
              <p class="number">
                {{ tindakan.count }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <Update />
    </div>
    <PrimaryModule />
    <KesihatanPersekitaran />
  </AdminBackground>
</template>



<script setup>
import KesihatanPersekitaran from '@/components/menu-items/section-menu/kesihatan-persekitaran-menu.vue'
import { useHttpService } from "@/httpService"
import { computed, onMounted, ref } from 'vue'

const years = ref([])
const states = ref(["Semua Negeri"])
const pbt = ref([])
const councils = ref([])
const selectedYear = ref(2025)
const selectedsState = ref('Semua Negeri')
const selectedPbt = ref('Semua PBT')

const GredPermisData = ref([])
const GredPermisNames = ref([])

const { httpGet, numberWithCommas } = useHttpService()

definePage({
  alias: '/pages/pages/inspektorat/ahli-pbt',
  meta: {
    layout: 'blank',
    public: true,
  },
})

const premisMakanan = ref({ 
  jumlahPremisYangDilesenkan: 0,
  jumlahDiperiksaDanDigredkan: 0,
  bilanganPremisDitutup: 0,
  bilanganKompaun: 0,
  bilanganNotis: 0,
  bilanganOperasi: 0,
  bilanganRampasan: 0,
  gredA: 0,
  gredB: 0,
  gredC: 0,
})

const premis = computed(() => [
  { title: 'Bilangan Premis Dilesenkan yang Mematuhi Kriteria', location: numberWithCommas(premisMakanan.value.jumlahPremisYangDilesenkan), color: 'linear-gradient(0deg, #0000FF 0%, #5F9EA0 100%)' },
  { title: 'Bilangan Premis Diperiksa dan Digredkan', location: numberWithCommas(premisMakanan.value.jumlahDiperiksaDanDigredkan), color: 'linear-gradient(0deg, #0000FF 0%, #5F9EA0 100%)' },
  { title: 'Gred A', location: numberWithCommas(premisMakanan.value.gredA), color: 'linear-gradient(0deg, #029708 0%, #013103 100%)'  },
  { title: 'Gred B', location: numberWithCommas(premisMakanan.value.gredB), color: 'linear-gradient(0deg, #FFD700 0%, #FFEC8B 100%)' },
  { title: 'Gred C', location: numberWithCommas(premisMakanan.value.gredC), color: 'linear-gradient(0deg, #FF0000 0%, #8B0000 100%)' },
])


const tindakanData = computed(() => [
  { title: 'Bil. Operasi', count: numberWithCommas(premisMakanan.value.bilanganOperasi), altText: 'First Image' },
  { title: 'Bil. Notis', count: numberWithCommas(premisMakanan.value.bilanganNotis), altText: 'Second Image' },
  { title: 'Bil. Kompaun', count: numberWithCommas(premisMakanan.value.bilanganKompaun), altText: 'Third Image' },
  { title: 'Bil. Sitaan', count: numberWithCommas(premisMakanan.value.bilanganRampasan), altText: 'Fourth Image' },
  { title: 'Bil. Premis Ditutup', count: numberWithCommas(premisMakanan.value.bilanganPremisDitutup), altText: 'Fifth Image' },
])

const responseData = ref(null)

async function loadDataFromApi(year = selectedYear.value, state = selectedsState.value, pbtValue = selectedPbt.value) {
  try {
    const plainStates = toRaw(state)
    let queryParams = `year=${year}`

    if (!plainStates.includes("Semua Negeri")) {
      if (Array.isArray(plainStates)) {
        plainStates.forEach(state => {
          const stateName = typeof state === "string" ? state : state.name || state.value
          if (stateName) {
            queryParams += `&states[]=${encodeURIComponent(stateName)}`
          }
        })
      } else {
        queryParams += `&states[]=${encodeURIComponent(plainStates)}`
      }
    }

    if (Array.isArray(pbtValue) && !pbtValue.includes('Semua PBT')) {
      pbtValue.forEach(pbt => {
        queryParams += `&councils[]=${encodeURIComponent(pbt)}`
      })
    }

    const url = `kesihatan-persekitaran/premis-makanan?${queryParams}`
    const response = await httpGet(url)

    years.value = response.years
    states.value = ["Semua Negeri"]
    response.states.forEach(state => {
      if (state && state !== "Modified Pbt") {
        states.value.push(state)
      }
    })
    councils.value = response.councils
    responseData.value = response
    var data=responseData.value.data.data
    premisMakanan.value = { 
      jumlahPremisYangDilesenkan: data.jumlah_premis_yang_dilesenkan,
      jumlahDiperiksaDanDigredkan: data.jumlah_diperiksa_dan_digredkan,
      bilanganPremisDitutup: data.bilangan_premis_ditutup,
      bilanganKompaun: data.bilangan_kompaun,
      bilanganNotis: data.bilangan_notis,
      bilanganOperasi: data.bilangan_operasi,
      bilanganRampasan: data.bilangan_rampasan,
      gredA: data.gred_a,
      gredB: data.gred_b,
      gredC: data.gred_c,
    }

    GredPermisNames.value = ["Restoran", "Gerai", "Kantin", "Lain-Lain"]

    GredPermisData.value = [
      [
        data.jumlah_restoran_gred_a,
        data.jumlah_gerai_gred_a,
        data.jumlah_kantin_gred_a,
        data.jumlah_lain_lain_gred_a,
      ],
      [
        data.jumlah_restoran_gred_b,
        data.jumlah_gerai_gred_b,
        data.jumlah_kantin_gred_b,
        data.jumlah_lain_lain_gred_b,
      ],
      [
        data.jumlah_restoran_gred_c,
        data.jumlah_gerai_gred_c,
        data.jumlah_kantin_gred_c,
        data.jumlah_lain_lain_gred_c,
      ],
    ]
  } catch (err) {
    console.error("loadDataFromApi failed:", err)
  }
}

function handleStateChange() {
  pbt.value = []
  if (!Array.isArray(selectedsState.value)) {
    selectedsState.value = selectedsState.value ? [selectedsState.value] : []
  }
  if (!Array.isArray(selectedPbt.value)) {
    selectedPbt.value = selectedPbt.value ? [selectedPbt.value] : []
  }
  if (selectedsState.value.includes("Semua Negeri") && selectedsState.value.length > 1) {
    selectedsState.value = selectedsState.value.filter(state => state !== "Semua Negeri")
  }
  if (selectedPbt.value.includes("Semua PBT") && selectedPbt.value.length > 1) {
    selectedPbt.value = selectedPbt.value.filter(pbt => pbt !== "Semua PBT")
  }
  if (selectedsState.value.length === 0) {
    selectedsState.value = ["Semua Negeri"]
  }
  if (selectedPbt.value.length === 0) {
    selectedPbt.value = ["Semua PBT"]
  }
  if (selectedsState.value.includes("Semua Negeri")) {
    Object.keys(councils.value).forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  } else {
    selectedsState.value.forEach(state => {
      if (councils.value[state] && typeof councils.value[state] === "object") {
        Object.keys(councils.value[state]).forEach(councilKey => {
          const council = councils.value[state][councilKey]
          if (council && council.value) {
            pbt.value.push(council.value)
          }
        })
      }
    })
  }

  console.log('Filtered PBT:', pbt.value)
}

onMounted(() => {
  loadDataFromApi()
})

watch(councils, newValue => {
  if (newValue) handleStateChange()
}, { immediate: true })


watch([selectedYear, selectedsState, selectedPbt], () => {
  loadDataFromApi(selectedYear.value, selectedsState.value, selectedPbt.value)
}, { immediate: true })
</script>


<style scoped>
.content-wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px;
  border-radius: 20px; 
  background-color: rgba(255, 255, 255, 65%); 
  box-shadow: 0 4px 15px rgba(0, 0, 0, 20%);
  inline-size: 100%;
  margin-block: 20px;
  margin-inline: 0;
  max-inline-size: 1200px;
}

.chart-wrapper {
  padding: 20px;
  border-radius: 10px;
  background: rgba(255, 254, 254, 80%);
  inline-size: 100%;
  margin-block-start: 40px;
  max-inline-size: 1400px;
}

.chart-note {
  inset-block-start: 10px;
  inset-inline-end: 10px;
  color: #0e0101;
  font-size: 0.9rem;
  padding: 5px 10px;
  border-radius: 5px;
}

.image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-block-end: 20px;
}

.pbt-image {
  block-size: auto;
  max-inline-size: 70%;
}

.line-under-image {
  border-radius: 5px;
  background-color: white;
  block-size: 5px;
  inline-size: 70%;
  margin-block-start: 10px;
}

h2 {
  color: rgb(21, 0, 105);
  font-size: 1.5rem;
  font-weight: bold;
  inline-size: 100%;
  margin-block: 20px 10px;
  text-align: start;
}

.input-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-block-end: 20px;
}

.input-item {
  flex: 1;
  margin-inline-end: 15px;
}

.input-item:last-child {
  margin-inline-end: 0;
}

.first-row {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(2, 1fr);
  margin-block-end: 20px;
}

.second-row {
  display: grid;
  gap: 20px;
  grid-template-columns: repeat(3, 1fr);
}

.box {
  position: relative;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  block-size: 100px;
  transition: transform 0.3s;
}

.box:hover {
  transform: translateY(-5px);
}

.box p,
.box .count {
  color: white;
  font-weight: bold;
  text-align: center;
}

.box p {
  font-size: 1rem;
}

.box .count {
  font-size: 2rem;
}

.premis {
  display: grid;
  grid-gap: 10px; /* Gap between the rows and columns */
  grid-template-columns: repeat(3, 1fr); /* 3 columns */
}

.premis-container {
  position: relative;
  overflow: hidden;
  border-radius: 10px;
}

.responsive-image {
  display: block;
  block-size: auto;
  inline-size: 100%;
}

.text-overlay {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-family: Arial, sans-serif;
  inset: 0;
  text-align: center; /* Centers the text horizontally */
}

.values-layered h3 {
  margin: 0;
  color: #150069;
  font-size: 18px;
  font-weight: 600;
  text-align: center;
}

.number {
  color: #a80000;
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

/* For larger screens, up to 1024px */
@media (max-width: 1024px) {
  .content-wrapper {
    padding: 15px;
  }

  h2 {
    font-size: 1.4rem;
  }

  .first-row,
  .second-row {
    gap: 15px;
    grid-template-columns: repeat(2, 1fr); /* Reduce to 2 columns */
  }

  .premis {
    grid-gap: 15px;
    grid-template-columns: repeat(2, 1fr); /* Reduce to 2 columns */
  }

  .box .count,
  .number {
    font-size: 1.8rem; /* Slightly smaller text */
  }
}

/* For medium screens, up to 768px */
@media (max-width: 768px) {
  .content-wrapper {
    padding: 10px;
  }

  h2 {
    font-size: 1.3rem;
  }

  .first-row,
  .second-row,
  .premis {
    grid-template-columns: 1fr; /* Stack items in a single column */
  }

  .box .count,
  .number {
    font-size: 1.6rem;
  }
  .chart-note {
    font-size: 0.7rem;
    padding: 3px 6px;
  }
  
}

/* For small screens, up to 480px */
@media (max-width: 480px) {
  .content-wrapper {
    padding: 8px;
  }

  h2 {
    font-size: 1.2rem;
  }

  .first-row,
  .second-row,
  .premis {
    grid-template-columns: 1fr; /* Single column layout */
  }

  .box {
    block-size: 80px; /* Adjust box height for smaller screens */
  }

  .box p {
    font-size: 0.9rem;
  }

  .box .count,
  .number {
    font-size: 1.4rem;
  }

  .values-layered h3 {
    font-size: 16px; /* Smaller heading font */
  }
}
</style>
